<div class="flex flex-column h-full">
    <div class="overflow-y-auto">
        <p-panelmenu [model]="items" styleClass="sidemenu" *ngIf="hasResourcesAccess">
            <ng-template #item let-item>
                <a pRipple class="menu-item" [routerLink]="shouldBlockNavigation(item) ? null : item.link" routerLinkActive="active" [pTooltip]="item.label" tooltipPosition="bottom" (click)="onMenuItemClick($event, item)">
                    <i-tabler [name]="item.icon" class="menu-item-icon ti-2xl"></i-tabler>
                    <span class="menu-item-label hide-on-collapse">
                        {{ item.label }}
                    </span>
                    <span class="ml-auto inline-flex gap-2">
                        <p-badge *ngIf="item.badge" [value]="item.badge" />
                        <i-tabler *ngIf="item.items?.length" [name]="item.expanded ? 'chevron-up' : 'chevron-down'"
                            class="ti-xl menu-item-expand-icon hide-on-collapse"></i-tabler>
                    </span>
                </a>
            </ng-template>
        </p-panelmenu>
    </div>
    <p-confirmDialog />
    <!-- <div class="mt-auto flex flex-column align-items-center justify-content-center py-3" (click)="logOut()">
        <button pButton text="true" class="menu-button" pTooltip="Logout" severity="secondary">
            <i-tabler name="logout"></i-tabler>
            <span>Logout</span>
        </button>
    </div> -->
</div>